import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const ArrowUpDown: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'm21 16-4 4-4-4' }],
    ['path', { d: 'M17 20V4' }],
    ['path', { d: 'm3 8 4-4 4 4' }],
    ['path', { d: 'M7 4v16' }],
  ],
];

export default ArrowUpDown;
